/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Input, InputNumber, Select } from "antd";
import TextArea from "antd/es/input/TextArea";
import { Rule } from "antd/es/form";

export function FormInput({
  id,
  name = "",
  label = "",
  placeholder = "",
  required = false,
  rules = undefined,
  widthSize = "medium",
  textArea = false,
  inputType = "text",
  value = "",
  onChange = () => {},
  onBlur = () => {},
  rows = 4,
  maxLength = undefined,
  disableSpecialCharCheck = false,
  prefix = "$",
  isDecimal = false,
  ...rest
}: any) {
  const normalizedRules: Rule[] = (rules ?? []).map((rule: any) => {
    const normalized: any = { ...rule };

    // Convert string "true"/"false" to actual booleans
    if (typeof rule.required === "string") {
      normalized.required = rule.required.toLowerCase() === "true";
    }

    // Remove or normalize other keys as needed
    for (const key in normalized) {
      if (normalized[key] === null) {
        delete normalized[key];
      }
    }

    return normalized;
  });


  const formatNumber = (value:any) => {
  if (value == null || value === "") return "";

  const num = Number(value);
  if (!Number.isFinite(num)) return String(value);

  return num.toLocaleString("en-US", { maximumFractionDigits: 20 });
};


  let inputElement;

  if (textArea) {
    inputElement = (
      <TextArea
        showCount
        maxLength={maxLength !== null ? maxLength : undefined}
        placeholder={placeholder}
        autoComplete="off"
        value={value}
        onChange={onChange}
        rows={rows ?? 4}
        style={{ width: "100%" }}
        {...rest}
      />
    );
  } else if (label.toLowerCase() === "currency") {
    inputElement = (
      <InputNumber
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        style={{ width: "100%" }}
        min={0}
        max={9999}
        prefix={prefix}
        formatter={(value: number | string | undefined) =>
         formatNumber(value)
        }
        parser={(value: string) => Number(value.replace(/[^\d.-]/g, ""))}
        {...rest}
      />
    );
  } else if (label.toLowerCase() === "phone no.") {
    inputElement = (
      <Input
        addonBefore={
          <Select
            defaultValue="+1"
            style={{ width: 80 }}
            onChange={(val) => {
              /* handle code change */
            }}
          >
            <Select.Option value="+1">+1</Select.Option>
            <Select.Option value="+91">+91</Select.Option>
            {/* Add more */}
          </Select>
        }
        placeholder={placeholder}
        value={value}
        onChange={(e) => {
          const sanitized = e.target.value.replace(/\D/g, "");
          onChange(sanitized);
        }}
        maxLength={10}
        style={{ width: "100%" }}
      />
    );
  } else if (inputType.toLowerCase() === "number") {
    inputElement = (
      <InputNumber
        placeholder={placeholder}
        autoComplete="off"
        onChange={onChange}
        style={{ width: "100%" }}
        min={0}
        onKeyDownCapture={(e) => {
          const isAllowedKey =
            /^\d$/.test(e.key) ||
            [
              "Backspace",
              "Delete",
              "Tab",
              "ArrowLeft",
              "ArrowRight",
              "Enter",
            ].includes(e.key) ||
            (isDecimal && e.key === ".");
          if (!isAllowedKey) e.preventDefault();
        }}
        {...rest}
      />
    );
  } else {
    inputElement = (
      <Input
        placeholder={placeholder}
        autoComplete="off"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        style={{ width: "100%" }}
        {...rest}
      />
    );
  }

  return (
    <Form.Item
      label={label}
      name={name}
      rules={normalizedRules}
      layout="vertical"
    >
      {inputElement}
    </Form.Item>
  );
}
